<template>
  <page>
    <div>
      <v-flex xs12>
        <form>
          <v-expansion-panels>
          <v-expansion-panel>
              <v-expansion-panel-header>
              <div>
                <v-icon>mdi-filter-variant</v-icon> Filters
              </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
              <v-card>
                <v-card-text>
                  <v-container fluid grid-list-lg>
                    <v-layout row wrap>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="buscls" v-model="filter.busCls" :label="label.busCls" item-text="label" item-value="value" :error-messages="errors.collect('filter.busCls')" data-vv-name="filter.busCls" :data-vv-as="label.busCls" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="tariff" v-model="filter.tariff" :label="label.tariff" item-text="label" item-value="value" :error-messages="errors.collect('filter.tariff')" data-vv-name="filter.tariff" :data-vv-as="label.tariff" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-autocomplete :items="benefit" v-model="filter.benefit" :label="label.benefit" item-text="label" item-value="value" :error-messages="errors.collect('filter.benefit')" data-vv-name="filter.benefit" :data-vv-as="label.benefit" clearable></v-autocomplete>
                      </v-flex>
                      <v-flex xl3 lg6 xs6>
                        <v-text-field v-model="filter.desc" :label="label.desc" :error-messages="errors.collect('desc')" data-vv-name="desc" :data-vv-as="label.desc"></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-spacer></v-spacer>
                    <v-btn color="red darken-1" text @click.native="doClearFilters">Clear Filters</v-btn>
                    <v-btn color="primary" text type="submit" @click.prevent="doFilters">Apply Filters</v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
        </form>
      </v-flex>
      <v-spacer class="mt-2"></v-spacer>
      <v-card>
        <v-flex xs12>
          <message :messages="messages"></message>
        </v-flex>
        <v-card-title>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click.native="doNew">
          New Tariff Factor<v-icon right>mdi-plus</v-icon>
        </v-btn>
        </v-card-title>
        <v-flex>
          <v-card>
            <v-data-table :headers="headers" :items="items" v-bind:options.sync="pagination" :server-items-length="totalItems" :loading="loading" :footer-props="{'items-per-page-options': itemsPerPage }" :no-data-text="noDataText">
              <template v-slot:item="row"><tr>
                <td class="text-xs-left">{{ row.item.busCls }} </td>
                <td class="text-xs-left">{{ row.item.tariff }} </td>
                <td class="text-xs-left">{{ row.item.benefit }} </td>
                <td class="text-xs-left">{{ row.item.seqNo }} </td>
                <td class="text-xs-left">{{ formatDate(row.item.effDate) }} </td>
                <td class="text-xs-left">{{ formatDate(row.item.expDate) }} </td>
                <td class="text-xs-left">{{ row.item.desc }} </td>
                <td class="text-xs-left">{{ row.item.fact1 }} </td>
                <td class="text-xs-left">{{ row.item.fact2 }} </td>
                <td class="text-xs-left">{{ row.item.fact3 }} </td>
                <td class="text-xs-left">{{ row.item.fact4 }} </td>
                <td class="text-xs-left">{{ row.item.fact5 }} </td>
                <td class="text-xs-left">{{ row.item.fact6 }} </td>
                <td class="table-action-header">
                  <table-action :rowData="row" query @query="doQuery(row.item)" review @review="doReview(row.item)" remove @remove="doPromptRemove(row.item)"></table-action>
                </td>
              </tr></template>
            </v-data-table>
          </v-card>
        </v-flex>
        <confirm v-model="promptRemove" @ok="doDelete">
          <p>Are you sure you want to delete the Tariff Factor?</p>
          <div class="queryValue">Business Class: {{selectedTariffFact.busCls}}<br/>
            Tariff: {{selectedTariffFact.tariff}}<br/>
            Benefit: {{selectedTariffFact.benefit}}<br/>
            Sequence No.: {{selectedTariffFact.seqNo}}<br/>
            Effective Date: {{selectedTariffFact.effDate}}<br/>
          </div>
        </confirm>
      </v-card>
    </div>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { expandURI, filterQuery } from '@/utils/ajax'
import clone from 'clone'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'

export default {
  data() {
    return {
      label: {
        busCls: 'Business Class',
        tariff: 'Tariff',
        benefit: 'Benefit',
        desc: 'Description'
      },
      filter: {
        busCls: null,
        tariff: null,
        benefit: null,
        desc: null
      },
      toogleArray: [false],
      submitting: false,
      buscls: [],
      tariff: [],
      benefit: [],
      loading: false,
      totalItems: 0,
      headers: [
        { text: 'Business Class', align: 'left', value: 'busCls' },
        { text: 'Tariffs', align: 'left', value: 'tariff' },
        { text: 'Benefits', align: 'left', value: 'benefit' },
        { text: 'Seq No.', align: 'left', value: 'seqNo' },
        { text: 'Effective Date', align: 'left', value: 'effDate' },
        { text: 'Expiry Date', align: 'left', value: 'expDate' },
        { text: 'Description', align: 'left', value: 'desc' },
        { text: 'Fact 1', align: 'left', value: 'fact1' },
        { text: 'Fact 2', align: 'left', value: 'fact2' },
        { text: 'Fact 3', align: 'left', value: 'fact3' },
        { text: 'Fact 4', align: 'left', value: 'fact4' },
        { text: 'Fact 5', align: 'left', value: 'fact5' },
        { text: 'Fact 6', align: 'left', value: 'fact6' },
        TableConst.tableActionHeader
      ],
      promptRemove: false,
      selectedTariffFact: {
        tariff: null,
        busCls: null,
        benefit: null,
        seqNo: null,
        effDate: null
      },
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('buscls')
      this.getCommonDataList('tariff')
      this.getCommonDataList('benefit')
      this.fetchData(true)
    },
    async fetchData(options) {
      this.resetMessages()
      const apiURI = this.menu.tariffFactList
      if (apiURI) {
        try {
          this.loading = true
          const { page, itemsPerPage } = this.pagination
          let expand = {
            page: page - 1,
            size: itemsPerPage,
            options: options
          }
          let messageFilters = clone(this.filter)

          const result = await this.$http.get(
            filterQuery(expandURI(apiURI, expand), messageFilters, this.pagination.sortBy, this.pagination.sortDesc)
          )
          if (result) {
            this.totalItems = result.data.totalElements
            const { data } = result.data
            this.items = []
            if (data) {
              data.map((tariffFact) => {
                const convertList = {
                  tariff: tariffFact.tariff,
                  busCls: tariffFact.busCls,
                  benefit: tariffFact.benefit,
                  seqNo: tariffFact.seqNo,
                  effDate: tariffFact.effDate,
                  expDate: tariffFact.expDate,
                  desc: tariffFact.desc,
                  fact1: tariffFact.fact1,
                  fact2: tariffFact.fact2,
                  fact3: tariffFact.fact3,
                  fact4: tariffFact.fact4,
                  fact5: tariffFact.fact5,
                  fact6: tariffFact.fact6
                }
                this.items.push(convertList)
              })
            }
          }
          this.loading = false
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
          this.loading = false
        }
      }
    },
    doClearFilters() {
      this.resetMessages()
      this.filter.busCls = null
      this.filter.tariff = null
      this.filter.benefit = null
      this.filter.desc = null
      this.fetchData(false)
    },
    doFilters() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.fetchData(false)
        } else {
          this.promptFieldCheck()
        }
      })
    },
    doNew() {
      const commit = {
        tarfFactMode: 'New',
        busCls: null,
        tariff: null,
        benefit: null,
        seqNo: null,
        effDate: null,
        fact1: null,
        fact2: null,
        fact3: null,
        fact4: null,
        fact5: null,
        fact6: null
      }
      sessionStorage.setItem('tariffFact', JSON.stringify(commit))
      this.$store.commit('TARIFF_FACTOR_COMMIT_KEY', commit)
      this.$router.push({ name: 'tarfFactDetail' })
    },
    doQuery(data) {
      const commit = {
        tarfFactMode: 'Query',
        busCls: data.busCls,
        tariff: data.tariff,
        benefit: data.benefit,
        seqNo: data.seqNo,
        effDate: data.effDate,
        fact1: data.fact1,
        fact2: data.fact2,
        fact3: data.fact3,
        fact4: data.fact4,
        fact5: data.fact5,
        fact6: data.fact6
      }
      sessionStorage.setItem('tariffFact', JSON.stringify(commit))
      this.$store.commit('TARIFF_FACTOR_COMMIT_KEY', commit)
      this.$router.push({ name: 'tarfFactDetail' })
    },
    doReview(data) {
      const commit = {
        tarfFactMode: 'Review',
        busCls: data.busCls,
        tariff: data.tariff,
        benefit: data.benefit,
        seqNo: data.seqNo,
        effDate: data.effDate,
        fact1: data.fact1,
        fact2: data.fact2,
        fact3: data.fact3,
        fact4: data.fact4,
        fact5: data.fact5,
        fact6: data.fact6
      }
      sessionStorage.setItem('tariffFact', JSON.stringify(commit))
      this.$store.commit('TARIFF_FACTOR_COMMIT_KEY', commit)
      this.$router.push({ name: 'tarfFactDetail' })
    },
    async doPromptRemove(data) {
      this.resetMessages()
      if (data) {
        try {
          const apiURI = this.menu.checkDeleteTariffFact
          const expand = {
            busCls: data.busCls,
            tariff: data.tariff,
            benefit: data.benefit,
            seqNo: data.seqNo,
            effDate: formatDisplayDateTime2(removeTime(data.effDate))
          }
          await this.$http.get(expandURI(apiURI, expand))
          this.selectedTariffFact.tariff = data.tariff
          this.selectedTariffFact.busCls = data.busCls
          this.selectedTariffFact.benefit = data.benefit
          this.selectedTariffFact.seqNo = data.seqNo
          this.selectedTariffFact.effDate = formatDisplayDate(data.effDate)
          this.promptRemove = true
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.fieldMessage(data)
            this.notify(data)
          }
        }
      }
    },
    doDelete() {
      this.resetMessages()
      if (this.selectedTariffFact) {
        const apiURI = this.menu.deleteTariffFact
        if (apiURI) {
          const expand = {
            busCls: this.selectedTariffFact.busCls,
            tariff: this.selectedTariffFact.tariff,
            benefit: this.selectedTariffFact.benefit,
            seqNo: this.selectedTariffFact.seqNo,
            effDate: this.selectedTariffFact.effDate
          }
          this.$http
            .delete(expandURI(apiURI, expand))
            .then((result) => {
              const data = result.data
              this.notify(data)
              this.promptRemove = false
              this.doInit()
            })
            .catch((err) => {
              this.promptRemove = false
              const { data } = err.response
              if (data) {
                this.message(data)
              }
            })
        }
      }
    }
  },
  computed: {
    menu() {
      return this.$store.state.tariffFactorParam.menu
    }
  },
  watch: {
    'pagination': function (value) {
      this.fetchData(false)
    }
  },
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin]
}
</script>
